// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__TL9Uz","logo":"Footer_logo__1dEML","socials":"Footer_socials__soOBA"};